import "./renderAmount.css";

export type RenderAmountProps = {
    value: number;
    selected: boolean;
    text?: string;
    onClicked: (amount: number) => void;
}

export function RenderAmount(props: RenderAmountProps) {

    const clicked = (event: any): void => {
        props.onClicked(props.value);
    }

    const renderText = () => {
        if (!props.text)
            return (<></>);

        return (<td>
            <div className="seva-info-text-bg">
                <div className="seva-info-text">{props.text}</div>
            </div>
        </td>);
    }

    return (<div className="donation-box-amount" onClick={clicked}>
        <table>
            <tbody>
                <tr>
                    <td>
                        <div className={"color-yb circle center-text " + (props.selected ? "color-yb-selected" : "")}>
                            <div className="amountText"> ${props.value}</div>
                        </div>
                    </td>
                    {renderText()}
                </tr>
            </tbody>
        </table>
    </div>)
}